export default function cookieAgree() {
  const $cookie = document.getElementById('js-cookie');
  const $agreeButton = $cookie.getElementsByClassName('js-agreeButton');
  const nodeAgreeButton = Array.prototype.slice.call($agreeButton, 0);
  const $closeButton = $cookie.getElementsByClassName('js-close');
  const nodeCloseButton = Array.prototype.slice.call($closeButton, 0);

  nodeAgreeButton.forEach(elem => {
    elem.addEventListener(
      'click',
      e => {
        e.preventDefault();
        e.stopPropagation();
        window.Cookies.set('cookie-agree', true, { expires: 365 });
        $cookie.classList.toggle('_close');
        $cookie.classList.toggle('_open');
      },
      true,
    );
  });

  nodeCloseButton.forEach(elem => {
    elem.addEventListener(
      'click',
      e => {
        e.preventDefault();
        e.stopPropagation();
        $cookie.classList.toggle('_close');
        $cookie.classList.toggle('_open');
      },
      true,
    );
  });
}
